import React from 'react';
import FixturesTable, { type FixtureRow } from '../components/WC/FixturesTable';
import GroupStandingsTable, { type StandingRow } from '../components/WC/GroupStandingsTable';
import TierTeamsTable, { type TierGroup } from '../components/WC/TierTeamsTable';
import WCPageSection from '../components/WC/WCPageSection';

const sampleFixtures: FixtureRow[] = [
  {
    dateLabel: 'Opening match',
    stage: 'Group A',
    homeTeam: 'Host nation',
    awayTeam: 'TBC',
    venue: 'TBC',
    time: 'TBC',
  },
  {
    dateLabel: 'Matchday 2',
    stage: 'Group A',
    homeTeam: 'Team A',
    awayTeam: 'Team B',
    venue: 'TBC',
    time: 'TBC',
  },
];

const sampleTiers: TierGroup[] = [
  {
    tier: 'Tier 1 — title contenders',
    teams: ['Example A', 'Example B', 'Example C'],
    notes: 'Replace with real seeding when announced.',
  },
  {
    tier: 'Tier 2 — dark horses',
    teams: ['Example D', 'Example E'],
  },
  {
    tier: 'Tier 3 — qualifiers',
    teams: ['Example F', 'Example G', 'Example H', 'Example I'],
  },
];

const sampleGroupA: StandingRow[] = [
  { rank: 1, team: 'Example A', played: 0, won: 0, drawn: 0, lost: 0, pts: 0, gf: 0, ga: 0 },
  { rank: 2, team: 'Example B', played: 0, won: 0, drawn: 0, lost: 0, pts: 0, gf: 0, ga: 0 },
  { rank: 3, team: 'Example C', played: 0, won: 0, drawn: 0, lost: 0, pts: 0, gf: 0, ga: 0 },
  { rank: 4, team: 'Example D', played: 0, won: 0, drawn: 0, lost: 0, pts: 0, gf: 0, ga: 0 },
];

function WC26() {
  const patternUrl = `${process.env.PUBLIC_URL || ''}/WC26-bg-pattern.svg`;

  return (
    <section
      className="page wc26-main-section"
      aria-labelledby="wc26-heading"
      style={{ backgroundImage: `url("${patternUrl}")` }}
    >
      <header className="wc26-hero">
        <div className="wc26-title-chip">
          <h1 id="wc26-heading" className="wc26-title">
            WC 26
          </h1>
        </div>
        <p className="wc26-intro">
          Track fixtures, tiers, and group tables here. Sample rows below, will be swapped in real data as the
          tournament approaches.
        </p>
      </header>

      <WCPageSection
        sectionId="wc26-fixtures"
        title="Fixtures"
        description="Add or import rows as the schedule is published."
      >
        <FixturesTable fixtures={sampleFixtures} caption="Example fixture list" />
      </WCPageSection>

      <WCPageSection
        sectionId="wc26-tiers"
        title="Teams by tier / pot"
        description="Use tiers, pots, or your own groupings — one row per category."
      >
        <TierTeamsTable
          groups={sampleTiers}
          caption="Example tier breakdown"
          tierColumnLabel="Category"
        />
      </WCPageSection>

      <WCPageSection
        sectionId="wc26-standings"
        title="Group standings"
        description="Points table per group; optional goals for and against when you want GD shown."
      >
        <GroupStandingsTable groupLabel="A" rows={sampleGroupA} caption="Group A (example)" />
      </WCPageSection>
    </section>
  );
}

export default WC26;
